import _ from 'lodash';

import './dashboard.scss';
import './comingSoon.scss';

/* @ngInject */
export default class DashboardController {
    constructor($scope, UiDisplayFactory, DashboardService, PermissionsFactory) {
        this.UiDisplayFactory = UiDisplayFactory;
        this.DashboardService = DashboardService;
        this.PermissionsFactory = PermissionsFactory;

        this.title = 'HEROPro';
        this.rules = {};
        this.dashboardModules = [];
        this.showBenjiLink = false;
        this.comingSoonStateName = '';
        this.showMobileAppMessaging = false;

        this.init();


        $scope.$on('UpdateDisplay', () => {
            // (ajt - 5/26/2016) TODO: Remove delay if the rules processing can be performed synchronously.
            _.defer(() => {
                this.setRules();
            });
        });
    }

    init() {
        this.setRules();

        if (this.PermissionsFactory.hasPermission('HeroPro.IntegratedExperience.Enabled')) {
            this.showMobileAppMessaging = true;
        }
    }

    setRules() {
        this.rules = this.UiDisplayFactory.getDisplayRules();
        if (this.rules.rulesLoaded === true) {
            const elements = this.DashboardService.getDashboard();
            this.dashboardModules = [];
            _.each(elements, (item) => {
                switch (item.name.toLowerCase()) {
                case 'start project':
                    item.isEnabled = this.rules.showStartProject;
                    break;
                case 'action items':
                    item.isEnabled = this.rules.showToDoSummary;
                    break;
                case 'pipeline summary':
                    item.isEnabled = this.rules.showPipelineSummary;
                    break;
                case 'coming soon':
                    item.isEnabled = this.rules.showComingSoon;
                    this.comingSoonStateName = this.UiDisplayFactory.getBlacklistStateName();
                    break;
                default:
                    console.log("unknown case for 'setRules' in dashboardController");
                }
                if (item.isEnabled === true) {
                    this.dashboardModules.push(item);
                }
            });
            this.showBenjiLink = this.rules.isBenjiUser;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.controller.js